import { Flex, Typography } from 'antd';
import clsx from 'clsx';
import React, { useContext } from 'react';
import { Languages } from '../../knowledge-base-common/knowledge-base-common.type';
import { langLabels, languages } from '../virtual-assistant.constants';
import { getLangValue, localize } from '/react4xp/mixins/helpers';
import { PartContext } from '/react4xp/parts/virtual-assistant/virtual-assistant';

const LanguageSelector = (props) => {
    const { language: activeLanguage } = useContext(PartContext);

    const handleChangeLanguage = (language: Languages) => {
        if (language !== activeLanguage) {
            const urlArr = window.location.href.split('/');
            window.location.href =
                urlArr.slice(0, 3).join('/') + '/' + language + '/' + urlArr.slice(4).join('/');
        }
    };

    return (
        <div className="languages-container">
            <Typography.Text
                strong
                style={{ fontSize: 16 }}
            >
                {localize('labels.preferred-language', props.translations)}
            </Typography.Text>

            <Flex
                wrap
                gap={36}
                justify="center"
                align="center"
                style={{
                    marginTop: 30,
                }}
            >
                {languages.map((language) => (
                    <button
                        key={language}
                        className={clsx({
                            'language-button': true,
                            'language-button_active': language === getLangValue(activeLanguage),
                        })}
                        onClick={() => handleChangeLanguage(language)}
                    >
                        {langLabels[language]}
                    </button>
                ))}
            </Flex>
        </div>
    );
};

export default LanguageSelector;
